import { Component, OnInit, OnDestroy, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { Subscription } from 'rxjs';
import { Ng2TableModule } from 'ng2-table/ng2-table';

import { QuotService, QuotFilter, Quot } from '../../services/quot.service';
import { ProductVntaService } from '../../services/product-vnta.service';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { Utils } from '../../util';

@Component({
  selector: 'app-read-quot',
  templateUrl: './read-quot.component.html',
  styleUrls: ['./read-quot.component.css']
})
export class ReadQuotComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};
  loading: boolean[] = [false, false, false];
  get loaded(): boolean { return !this.loading.includes(false); }

  quots: any[] = [];

  quotsSub: Subscription;
	settingsSub: Subscription;
	prVntaSub: Subscription;

	data: Array<any>;
	rows: Array<any> = [];
	columns: Array<any> = [
    { title: 'Folio', name: 'name' },
    { title: 'Cliente', name: 'customerName' },
		{ title: 'Fecha', name: 'date' },
		{ title: 'Estado', name: 'status' },
		{ title: 'Acciones',  name: 'actionGroup', sort: false, actions: {
			type: 'group',
			buttons: [
				{ name: 'duplicate', title: '', styleIcon: 'queue', action: 'onDuplicate', styleClass: 'btn-floating btn waves-effect light-blue darken-1' },
				{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit', styleClass: 'btn-floating btn waves-effect light-green darken-1' },
				{ name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete', styleClass: 'btn-floating btn waves-effect red darken-2', }
			]
		}}
	];

	page = 1;
	itemsPerPage = 10;
	maxSize = 5;
	numPages = 1;
	length = 0;
	config: any = {
		paging: true,
		sorting: { columns: this.columns },
		filtering: { filterString: '' },
		api: {
      onDuplicate: this.onDuplicate.bind(this),
			onEdit: this.onEdit.bind(this),
			onDelete: this.onDelete.bind(this)
		}
  };
  
  receivedAll: boolean = false;

	constructor(
		private service: QuotService,
    private prVntaService: ProductVntaService,
    private fb: FormBuilder,
    private settings: CatalogsSettingsService,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
	) {
    //let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser.email).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else this.allowed = true;
    });

    this.settingsSub = this.settings.getPayrollSettings('1').subscribe(setting => {
		  this.settingsSub.unsubscribe();
      this.itemsPerPage = setting.tableQuantity;
      this.loading[0] = true;
    });
		this.quotsSub = this.service.getQuotsFifteenDays({onEmpty: () => {
      this.loading[1] = true;
    } }).subscribe(tempQuot => {
      this.loading[1] = true;
			this.quots = tempQuot.map(quot => {
        quot.name = quot.folio;
        quot.customerName = quot.customerObj.name;
				return quot;
			});
      this.filterBar = new QuotFilter(this.quots, {} );//JSON.parse(this.filterBar.json)
      this.applyFilterBar();
    });
    this.prVntas = {};
    this.prVntaSub = this.prVntaService.getPrVntas({onEmpty: () => {
      this.loading[2] = true;
      toast('Advertencia: No hay productos de venta.', 3000);
    } }).subscribe(prVntas => {
      this.rowsRead[0] = prVntas.map(prVnta => {
        this.prVntas[prVnta.id] = prVnta;
        prVnta.class = prVnta.data.name;
        return prVnta;
      });
      this.loading[2] = true;
    });
	}

  ngOnInit() {
    //change activity
    /* let sub = this.service.getQuots().subscribe(prClients => {
      sub.unsubscribe();
      prClients.map(({id, sections: [s1], ...prClient}) => {
        let newSections = [];
        if(s1 && s1.backInk > 0){
          s1.activities = s1.activities.map(({name, ...a}) => ({ name: name.replace('201 - Impresión', '201 - Impresión Frente').replace('201 -Impresión', '201 - Impresión Frente'), ...a }));
          newSections.push(s1);
        }
        //console.log(newSections);
        this.service.updateQuot(id, {sections: newSections});
      })
    }) */
  }
  ngOnDestroy() {
    this.quotsSub.unsubscribe();
		this.prVntaSub.unsubscribe();
  }

	onCellClick(data: any): any {
    this.service.windowReplace('view', data.row.id);
	}

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.openModalRead(0);
  }

	onDuplicate(data: any) {
    if(!this.permission.createAction) return toast('No tiene los permisos para duplicar.', 2000);
    let {
      id, createdAt, updatedAt, companyObj, folio, status, date,
      createdByObj, createdByRef,
      customerName, customerObj, customerRef,
      employeeSignName, employeeSignObj, employeeSignRef,
      keyPersonJob, keyPersonObj,
      prVntaObj, prVntaRef,
      ...quot
    } = data.row;
    let duplicate = {
      createdByRef: createdByRef.id,
      customerRef: customerRef.id,
      employeeSignRef: employeeSignRef.id,
      prVntaRef: prVntaRef.id,
      status: "Pendiente",
      date: this.today,
      ...quot
    }
    
    let folioSub = this.service.getQuots().subscribe( quots => {
      folioSub.unsubscribe();
      let [quot] = quots.sort(({folio: f1}, {folio: f2}) => f1.slice(3) < f2.slice(3) ? 1 : -1);
      let nextFolio = this.authService.currentUser.initials + Utils.getNextFolio(quot ? +quot.folio.slice(3) : '');
      duplicate.folio = nextFolio;
      let msg = `Esta acción duplica la cotización ${folio} del cliente ${customerName}. La nueva cotización se guardará con la fecha de hoy bajo y el nuevo folio ${nextFolio}. ¿Desea continuar?`;
      if(confirm(msg)){
        this.service.addQuot(duplicate);
        alert(`La nueva cotización se ha generado exitosamente con el folio ${nextFolio}`);
      }
    });
	}
	onEdit(data: any) {
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
		this.service.windowReplace('edit', data.row.id);
	}
	onDelete(data: any) {
    if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
		this.service.deleteQuot(data.row.id);
  }
  

  get today(){
    var today = new Date();
    var dd:string = today.getDate() + '';
    var mm:string = today.getMonth()+ 1 + '';
    var yyyy = today.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    return yyyy + '-' + mm + '-' + dd;
  }

  ////////////////////////////////////////////////////////////////////FilterBar
  filterBar: QuotFilter = new QuotFilter([],{});
  applyFilterBar(){
    //localStorage.quotRead = this.filterBar.json;

    this.data = this.filterBar.filteredData;
    this.length = this.data.length;
    this.onChangeTable(this.config);
  }
  onChangeDateFilterBar(){
    if(this.filterBar.dateIndex && !this.receivedAll){
      this.quotsSub.unsubscribe();
      this.loading[1] = false;
      this.quotsSub = this.service.getQuots({onEmpty: () => {
        this.loading[1] = true;
      } }).subscribe(tempQuots => {
        this.loading[1] = true;
        this.quots = tempQuots.map(quot => {
          quot.name = quot.folio;
          quot.customerName = quot.customerObj.name;
          return quot;
        });
        this.filterBar = new QuotFilter(this.quots, JSON.parse(this.filterBar.json) );
        this.applyFilterBar();
      });
      this.receivedAll = true;
    }else{
      this.applyFilterBar();
    }
  }
  ////////////////////////////////////////////////////////////////////FilterBar

	// *************** Table functionality *************** //
	changePage(page: any, data: Array<any> = this.data): Array<any> {
		let start = (page.page - 1) * page.itemsPerPage;
		let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

		return data.slice(start, end);
	}

	changeSort(data: any, config: any): any {
		if (!config.sorting) {
			return data;
		}

		let columns = this.config.sorting.columns;
		let columnName: string;
		let sort: string;

		for (let i = 0; i < columns.length; i++) {
			if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
				columnName = columns[i].name;
				sort = columns[i].sort;
			}
		}

		if (!columnName) {
			return data;
		}

		// simple sorting
		return data.sort((previous: any, current: any) => {
			if (previous[columnName] > current[columnName]) {
				return sort === 'desc' ? -1 : 1;
			} else if (previous[columnName] < current[columnName]) {
				return sort === 'asc' ? -1 : 1;
			}

			return 0;
		});
	}

	changeFilter(data: any, config: any): any {
		let filteredData: Array<any> = data;

		this.columns.forEach((column: any) => {
			if (column.filtering) {
				filteredData = filteredData.filter((item: any) => {
					return item[column.name].match(column.filtering.filterString);
				});
			}
		});

		if (!config.filtering) {
			return filteredData;
		}

		if (config.filtering.columnName) {
			return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
		}

		let tempArray: Array<any> = [];

		filteredData.forEach((item: any) => {
			let flag = false;

			this.columns.forEach((column: any) => {
				if (item[column.name] &&
					item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
					flag = true;
				}
			});

			if (flag) {
				tempArray.push(item);
			}
		});

		filteredData = tempArray;

		return filteredData;
	}

	onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
		if (config.filtering) {
				Object.assign(this.config.filtering, config.filtering);
		}

		if (config.sorting) {
				Object.assign(this.config.sorting, config.sorting);
		}

		let filteredData = this.changeFilter(this.data, this.config);
		let sortedData = this.changeSort(filteredData, this.config);

		this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
		this.length = sortedData.length;
	}

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.r_data = this.rowsRead[index];
    
    this.r_config = this.r_configs[index];
  
    this.r_onChangeTable(this.r_config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    this.selectedIds[this.currentReadIndex] = data.row.id;
    this.continue()
  }
  continue(){
    this.closeModalRead();
    this.service.windowReplace('add', this.selectedPrVntaId);
  }

  selectedIds: string [] = [];
  prVntas: any = {};
  get selectedPrVntaId(): string { return this.selectedIds[0] }
  get readValid(){ return !!this.selectedPrVntaId };
  currentReadIndex: number;
  rowsRead = [[]];
  columnsRead = [
    [//prVnta
      {title: 'Nombre', name: 'name',sort: 'asc'},
      {title: 'Descripción', name: 'description'},
      {title: 'Clasificación' , name: 'class'},
      {title: 'Código', name: 'code'},
    ]
  ]


  r_data:Array<any>;
  r_rows:Array<any> = [];
  r_page:number = 1;
  r_itemsPerPage:number = 5;
  r_maxSize:number = 5;
  r_numPages:number = 1;
  r_length:number = 0;

  
  r_configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));
  r_config = this.r_configs[0];

  /*********** Filter, sort, and pagination */

	r_changePage(page:any, data:Array<any> = this.r_data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  r_changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.r_config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }
    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  r_changeFilter(data:any, config:any):any {
    console.log(this.columnsRead[this.currentReadIndex])
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });
    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.r_config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  r_onChangeTable(config:any, page:any = {page: this.r_page, itemsPerPage: this.r_itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.r_config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.r_config.sorting, config.sorting);
    }

    let filteredData = this.r_changeFilter(this.r_data, this.r_config);
    let sortedData = this.r_changeSort(filteredData, this.r_config);
    this.r_rows = page && config.paging ? this.r_changePage(page, sortedData) : sortedData;
    this.r_length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA
}
